import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service3 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (
    <div className="about-events-container">
                {/* First table for images and content */}

                <div className="about-events-images">
                                 <img src="/images/dayout.webp"  />
                                 <img src="/images/dayout2.webp"  />
                                 <img src="/images/dayout3.webp" />
                                 <img src="/images/dayout4.webp" />
                               </div>

                        <div className="about-events-content">
                            <h2 className="about-header-service">Spend The Day At Cocoloco</h2>
                            <p className="about-events-description">
                            <p>At Cocoloco, we offer exclusive spend the day packages designed to cater to all types of gatherings, whether it's an office retreat, a family get-together, or any special occasion. Our day and night packages are thoughtfully crafted to ensure everyone has a memorable and enjoyable experience.</p>
                            <p>Each package includes a refreshing welcome drink to kick off your day, followed by a delicious buffet tailored to your preferences. As the day winds down, enjoy a relaxing evening coffee, perfect for unwinding after your activities. For those looking to cool off, our pool is open to all guests, offering a refreshing escape in the midst of our lush surroundings.</p>
                            </p>
                            <button className="service-button" onClick={handleNavigate}>
                                Click Here For See More Gallery ..
                            </button>
                        </div>

                                                        </div>


    );
};

export default Service3;
